import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import ConnectedDevice from "../../Assets/svgs/ConnectedSVG.svg";
import { Counter } from "../../components/Billing/Counter/Counter";
// import BillingDetails from "../../components/Billing/BillingDetails";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        color: (theme) =>
          theme.palette.mode === "dark" ? "grey.300" : "grey.800",
        fontSize: "0.875rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};
const Billing_new = () => {
  const [count, setCount] = React.useState(5);

  let paymentdetails = {
    userid: "xyz",
    ntlno: 12345,
    totalamount: count * 250,
  };

  return (
    <Box sx={{ mr: 3, mt: 2 }}>
      <div style={{ width: "100%" }}>
        <Box padding={"1rem 0 0.5rem 0"}>
          <Typography variant="h5" fontWeight="bold">
            Select Screen
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Box bgcolor={"#ffffff"} p={4} borderRadius={2}>
              <Item
                sx={{
                  height: {
                    xl: 210,
                    lg: 210,
                    md: "auto",
                    sm: "auto",
                    xs: "auto",
                  },
                }}
              >
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  flexWrap={{
                    xl: "nowrap",
                    lg: "nowrap",
                    md: "nowrap",
                    sm: "nowrap",
                    xs: "wrap",
                  }}
                  gap={4}
                >
                  <Box display={"flex"} flexDirection={"column"}>
                    <Box
                      display={"flex"}
                      justifyContent={{
                        sm: "center",
                        xs: "center",
                        xl: "start",
                        lg: "start",
                      }}
                    >
                      <img
                        src={ConnectedDevice}
                        width={150}
                        height={150}
                        alt="img"
                      />
                    </Box>
                    <span>
                      What is the Total number of screen you will be using?
                    </span>
                  </Box>

                  <Box
                    display={"flex"}
                    justifyContent={{ sm: "center", xs: "center" }}
                    flexDirection={"column"}
                    alignItems={"center"}
                    width={{
                      xl: "auto",
                      lg: "auto",
                      md: "auto",
                      sm: "100%",
                      xs: "100%",
                    }}
                  >
                    <Counter
                      onCountChange={(count) => {
                        setCount(count);
                      }}
                      screens={count}
                    />
                  </Box>
                </Box>

                <Box display={"flex"} justifyContent={"end"}>
                  <form
                    action="https://customer.nayatel.com/AlfalahBank/index_new.php"
                    target="_blank"
                    method="post"
                  >
                    <input
                      type="hidden"
                      name="paymentData"
                      value={paymentdetails}
                    />
                    <Button variant="contained" type="submit" sx={{ mt: 2 }} >
                      Proceed
                    </Button>
                  </form>
                </Box>
              </Item>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <Box bgcolor={"#ffffff"} p={4} borderRadius={2}>
              <Item
                sx={{
                  height: {
                    xl: 210,
                    lg: 210,
                    md: "auto",
                    sm: "auto",
                    xs: "auto",
                  },
                }}
              >
                <div className="wrapper">
                  <div className="cardtitle">
                    <p>Order Details</p>
                  </div>
                  <div
                    className="screendetailstitle"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <div className="leftside">Total Screens:</div>
                    <div className="rightside">(Amount/month)</div>
                  </div>
                  <div
                    className="screendetails"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      color: "black",
                    }}
                  >
                    <div>{count} - Screens</div>
                    <div>{count * 250}</div>
                  </div>
                  <Divider
                    sx={{
                      borderBottomWidth: 3,
                      backgroundColor: "#DEDEDE",
                      mb: 2,
                      mt: 2,
                    }}
                  />
                  <div
                    className="totalamountwrapper"
                    style={{
                      backgroundColor: "#EDEEEE",
                      height: 77,
                      padding: 8,
                    }}
                  >
                    <span>Total Payment</span>
                    <div
                      className="withtaxesandshipping"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "12px",
                      }}
                    >
                      <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                        (excl. Taxes & Shiipping)
                      </span>
                      <span style={{ color: "#E85626" }}>{count * 250}</span>
                    </div>
                  </div>
                </div>
              </Item>
            </Box>
          </Grid>
        </Grid>

        {/* <Box padding={"1rem 0 1rem 0"}>
          <Typography variant="h5" fontWeight="bold">
            Billing History
          </Typography>
          <BillingDetails data={[]} />
        </Box> */}
      </div>
    </Box>
  );
};

export default Billing_new;
